import React, { useState } from "react";
import { Button, FormGroup, Input } from "reactstrap";
import { FiPlus } from "react-icons/fi";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { getAPIURL, getVendorID } from "../../services/helper";
import http from "../../services/http";
import {
  addNewProduct,
  setLoading,
} from "../../ReduxToolkit/Reducers/ProductsReducer";
import SelectCategory from "./AddProduct/ProductAdd/SelectCategory";

export default function AddVariableProduct() {
  // ✅ State for modal
  const [modalOpen, setModalOpen] = useState(false);
  const [productName, setProductName] = useState("");
  const [categories, setCategories] = useState([]);
  const [productSKU, setSKU] = useState("");
  const dispatch = useDispatch();
  const api_url = getAPIURL();
  const vendor_id = getVendorID();
  // ✅ Handle adding product locally
  const handleAddProduct = async () => {
    if (productName.trim() === "" || productSKU.trim() === "") {
      toast.error("Please enter product name and price");
      return;
    }

    const newProduct = {
      name: productName,
      sku: productSKU,
      categories: categories.map((cat) => cat.id),
      vendor_id,
    };

    // return console.log(newProduct);

    try {
      dispatch(setLoading(true));
      const resp = await http.post(`${api_url}/products/variable`, newProduct);

      dispatch(setLoading(false));

      const { success, data: product } = resp.data;
      if (!success) return toast.error("Error while adding product");
      console.log(product);
      dispatch(addNewProduct(product));
      toast.success("Variable product added successfully");
      setProductName("");
      setSKU("");
      setModalOpen(false);
    } catch (e) {
      console.error("Error while adding variable product", e);
      dispatch(setLoading(false));
    }
  };

  const onCategoriesChang = (key, value) => {
    setCategories(value);
  };

  const toggleModal = () => setModalOpen(!modalOpen);

  return (
    <div className="text-center">
      <Button color="info" className="add-product-btn" onClick={toggleModal}>
        Add Variable <FiPlus size={16} />
      </Button>

      <Modal isOpen={modalOpen} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Add New Product</ModalHeader>
        <ModalBody>
          <Input
            placeholder="Product Name"
            value={productName}
            onChange={(e) => setProductName(e.target.value)}
            className="mb-2"
          />
          <Input
            placeholder="SKU"
            type="text"
            value={productSKU}
            onChange={(e) => setSKU(e.target.value)}
          />
          <FormGroup>
            <SelectCategory
              title=""
              value={categories || []}
              onFormChange={onCategoriesChang}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleAddProduct}>
            Add
          </Button>{" "}
          <Button color="danger" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
